import {
  Circle5,
  Timer5Body,
  Timer5Center,
  Timer5Header,
  Timer5LeftItemWrapper,
  Timer5LeftWrapper,
  Timer5NextBlindWrapper,
  Timer5Notice,
  Timer5NowBlindWrapper,
  Timer5PrizeItem,
  Timer5RightWrapper,
  Timer5Wrapper,
  Timer5Box,
  Timer5blindWrapper,
  Timer5PrizeItemTop3,
  Timer5Background,
} from "./styles";
import { formatNumber } from "../../../utils/timer";
import { useRef, useState } from "react";
import TimerPrizeBox from "../component/timer-prize-box";
import AdVideo from "../../../component/AdVideo";
import { useCapture } from "../../../hooks/use-capture";
import { CaptureButton } from "../../../component/CaptureButton";
import { useCopyTournamentText } from "../../../hooks/use-copy-tournament-text";
import { useClock } from "../hooks/use-clock";
import { Helmet } from "react-helmet";

const UserTimer5 = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { handleCapture } = useCapture();
  const { copyTournamentText } = useCopyTournamentText();
  const radius = 304;
  const circumference = 2 * Math.PI * radius;

  const {
    timeInfo,
    userCount,
    reBuyInUserCount,
    entryUserCount,
    adOnUserCount,
    stack,
    avgStack,
    pub,
    coverImage,
    backgroundImage,
    isAd,
    setIsAd,
    data,
    visibleRanks,
    getNextBlind,
    getNowBlind,
    getData,
    subPrizeFont,
  } = useClock();

  const calculateStrokeDashoffset = () => {
    if (timeInfo.currentLevel && timeInfo.elapsedTimeInCurrentLevelMs) {
      const progress =
        timeInfo.elapsedTimeInCurrentLevelMs /
        (timeInfo.currentLevel.time * 60000);
      return circumference * (1 - progress);
    }
    return circumference;
  };

  const [planCompleteOpen, setPlanCompleteOpen] = useState(false);

  return (
    <>
      <Helmet>
        <title>{data?.title}</title>
      </Helmet>
      <Timer5Wrapper ref={containerRef}>
        {backgroundImage && (
          <Timer5Background backgroundImage={backgroundImage} />
        )}

        <Timer5Header>
          <div className="tournament-info-row">
            {coverImage && <img src={coverImage} alt="펍 로고" />}
            <div className="titleWrapper">
              <div className="title">{data?.title}</div>
              <div className="type">
                <span>{data?.subTitle}</span>
              </div>
            </div>
          </div>
          <div className="pub-name">{pub?.cafeName}</div>
        </Timer5Header>

        <Timer5Center>
          <Circle5
            break={
              timeInfo.currentLevel?.type === "BREAK" ||
              (timeInfo?.elapsedTimeMs && timeInfo?.elapsedTimeMs < 0)
                ? true
                : false
            }
          >
            <defs>
              <linearGradient
                id="progressGradient"
                x1="100%"
                y1="100%"
                x2="0%"
                y2="0%"
              >
                <stop
                  offset="0%"
                  stop-color={
                    timeInfo.currentLevel?.type !== "BREAK" &&
                    timeInfo?.elapsedTimeMs &&
                    timeInfo?.elapsedTimeMs > 0
                      ? "rgba(55, 244, 250, 0)"
                      : "rgba(167, 2, 1, 0)"
                  }
                />
                <stop
                  offset="25%"
                  stop-color={
                    timeInfo.currentLevel?.type !== "BREAK" &&
                    timeInfo?.elapsedTimeMs &&
                    timeInfo?.elapsedTimeMs > 0
                      ? "rgba(55, 244, 250, 0)"
                      : "rgba(167, 2, 1, 0)"
                  }
                />
                <stop
                  offset="30%"
                  stop-color={
                    timeInfo.currentLevel?.type !== "BREAK" &&
                    timeInfo?.elapsedTimeMs &&
                    timeInfo?.elapsedTimeMs > 0
                      ? "rgba(55, 244, 250, 0.3)"
                      : "rgba(167, 2, 1, 0.3)"
                  }
                />
                <stop
                  offset="50%"
                  stop-color={
                    timeInfo.currentLevel?.type !== "BREAK" &&
                    timeInfo?.elapsedTimeMs &&
                    timeInfo?.elapsedTimeMs > 0
                      ? "rgba(55, 244, 250, 1)"
                      : "rgba(167, 2, 1, 1)"
                  }
                />
                <stop
                  offset="100%"
                  stop-color={
                    timeInfo.currentLevel?.type !== "BREAK" &&
                    timeInfo?.elapsedTimeMs &&
                    timeInfo?.elapsedTimeMs > 0
                      ? "rgba(55, 244, 250, 1)"
                      : "rgba(167, 2, 1, 1)"
                  }
                />
              </linearGradient>
            </defs>
            <circle
              className="progress"
              r={radius}
              cx="418"
              cy="398"
              strokeDasharray={circumference}
              strokeDashoffset={
                timeInfo.currentLevel &&
                timeInfo.elapsedTimeInCurrentLevelMs &&
                timeInfo.elapsedTimeMs &&
                timeInfo.elapsedTimeMs > 0
                  ? calculateStrokeDashoffset() * 0.75
                  : 1
              }
            />
          </Circle5>
          <div className="timer-wrapper">
            <img
              src="/image-web/timer/timer5-circle.png"
              alt="timer background"
            />
            <Timer5Box>
              <div className="level-break">
                <img
                  className="logo"
                  src={`/image-web/timer/timer4-logo.svg`}
                  alt="logo"
                />
                <div
                  className={`now-level ${
                    timeInfo.currentLevel?.type === "BREAK" && "break "
                  }`}
                >{`${
                  data?.timerDto &&
                  timeInfo?.elapsedTimeMs &&
                  timeInfo?.elapsedTimeMs > 0
                    ? timeInfo.currentLevel?.type === "LEVEL"
                      ? "현재 " + timeInfo.currentLevel.level + "LV"
                      : "BREAK"
                    : "시작 준비중"
                }`}</div>
              </div>

              <div
                className={`time ${
                  timeInfo.currentLevel?.type === "LEVEL" &&
                  timeInfo?.elapsedTimeMs &&
                  timeInfo?.elapsedTimeMs > 0 &&
                  "level "
                }`}
              >
                {timeInfo.remainingTimeInCurrentLevel}
              </div>
            </Timer5Box>

            <Timer5blindWrapper>
              <Timer5NowBlindWrapper>
                <div className="title">NOW BLINDS</div>
                <div className="value">{getNowBlind()}</div>
              </Timer5NowBlindWrapper>
              <Timer5NextBlindWrapper>
                <div className="title">NEXT BLINDS</div>
                <div className="value">{getNextBlind()}</div>
              </Timer5NextBlindWrapper>
            </Timer5blindWrapper>
          </div>
        </Timer5Center>

        <Timer5Body>
          <Timer5LeftWrapper>
            <Timer5LeftItemWrapper isRed={false}>
              <div className="title">PLAYERS</div>
              <div className="value">{`${userCount} / ${
                adOnUserCount + reBuyInUserCount + entryUserCount
              }`}</div>
            </Timer5LeftItemWrapper>
            <Timer5LeftItemWrapper isRed={false}>
              <div className="title">TOTAL TIME</div>
              <div className="value">{timeInfo.elapsedTime}</div>
            </Timer5LeftItemWrapper>
            <Timer5LeftItemWrapper isRed={false}>
              <div className="title">TOTAL STACKS</div>
              <div className="value">{formatNumber(stack)}</div>
            </Timer5LeftItemWrapper>
            <Timer5LeftItemWrapper isRed={false}>
              <div className="title">AVG STACKS</div>
              <div className="value">{formatNumber(avgStack)}</div>
            </Timer5LeftItemWrapper>
            <Timer5LeftItemWrapper isRed={true}>
              <div className="title">NEXT BREAK</div>
              <div className="value">{timeInfo.timeUntilNextBreak}</div>
            </Timer5LeftItemWrapper>
          </Timer5LeftWrapper>
          <Timer5RightWrapper>
            <div className="prize-wrapper">
              <div className="title">PRIZE POOL</div>
              {data?.moneyInChip.map((item: any, index: number) =>
                index < 3 ? (
                  <Timer5PrizeItemTop3 subPrizeFont={subPrizeFont}>
                    <div className={`rank`}>{`${index + 1}${
                      index === 0
                        ? "st"
                        : index === 1
                          ? "nd"
                          : index === 2
                            ? "rd"
                            : "th"
                    }`}</div>
                    <TimerPrizeBox data={data} item={item} index={index} />
                  </Timer5PrizeItemTop3>
                ) : (
                  visibleRanks.includes(index + 1) && (
                    <Timer5PrizeItem
                      length={data?.moneyInChip.length}
                      subPrizeFont={subPrizeFont}
                    >
                      <div className={`rank`}>{`${index + 1}${
                        index === 0
                          ? "st"
                          : index === 1
                            ? "nd"
                            : index === 2
                              ? "rd"
                              : "th"
                      }`}</div>
                      <TimerPrizeBox data={data} item={item} index={index} />
                    </Timer5PrizeItem>
                  )
                ),
              )}
            </div>
            <Timer5Notice
              dangerouslySetInnerHTML={{
                __html: data?.notice
                  ? data.notice.replace(/\n/g, "<br />")
                  : "",
              }}
            />
          </Timer5RightWrapper>
        </Timer5Body>
        {isAd && (
          <AdVideo
            onClose={() => setIsAd(false)}
            data={data}
            timeInfo={timeInfo}
            coverImage={coverImage}
            stack={stack}
            avgStack={avgStack}
          />
        )}
      </Timer5Wrapper>
      <CaptureButton
        onCapture={() => handleCapture(containerRef.current)}
        onCopyText={() => copyTournamentText(data, timeInfo)}
      />
    </>
  );
};
export default UserTimer5;
